import gql from "graphql-tag";

export const getGroupMembersWithAggregation = gql`
  query GetGroupMembersWithAggregation($groupId: String, $paginationArguments: PaginationArgumentsForwardInput) {
    GetGroupMembersWithAggregation(input: { groupId: $groupId, paginationArguments: $paginationArguments }) {
      connection {
        totalCount
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            relation
            projectsCount
            status
            membersResponse {
              memberStatus
              roles {
                systemRole
                description
                organizationId
                groupId
              }
              user {
                email
                userId
                memberId
                photoUrl
                displayName
              }
            }
          }
        }
      }
    }
  }
`;
